import { useCachedHook } from "../../../Context/DynamicContext/useCachedHook";
import { type MetricWSnap } from "../../../types";

// TODO: Implement the actual logic to fetch Kubernetes metrics, this currently is a placeholder.
// eslint-disable-next-line @eslint-react/hooks-extra/no-useless-custom-hooks
const useNonCachedKubernetesMetrics = (): [MetricWSnap[], boolean] => {
  const metricsList: MetricWSnap[] = [];
  const isLoading = false;

  return [metricsList, isLoading];
};

export function useKubernetesMetrics() {
  return useCachedHook(useNonCachedKubernetesMetrics);
}
